import { Component, OnInit } from '@angular/core';
import { SearchService } from '../shared/services/search.service';
import { Jurisdiction } from '../shared/models/jurisdiction';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UpdateUboPercentage } from '../shared/models/UpdateUboPercentage';
import { MatDialog } from '@angular/material/dialog';
import { ConfigurationDialogComponent } from '../shared/dialog/configuration-dialog/configuration-dialog.component';
import { SnackbarService } from '../shared/services/snackbar.service';

@Component({
  selector: 'xp-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrl: './admin-page.component.scss'
})
export class AdminPageComponent implements OnInit {

    jurisdictions: Jurisdiction[] = [];
    form: FormGroup;
    postData: UpdateUboPercentage[] = [];
    displayedColumns: string[] = ['srNo','jurisdictionName', 'uboPercentage', 'fallbackMatterId', 'individualCharge', 'companyCharge', 'actions'];

    constructor(private searchService: SearchService, private dialog: MatDialog, public snackbarService: SnackbarService) { }

    ngOnInit(): void {
        this.searchService.getAllJurisdictions().subscribe((res: Jurisdiction[]) => {
            if (res) {
                this.jurisdictions = res;
            }
        })

    }

    openEditDialog(jurisdiction: Jurisdiction): void {
        const dialogRef = this.dialog.open(ConfigurationDialogComponent, {
            width: '500px',
            disableClose: true, 
            data: { ...jurisdiction }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                const index = this.jurisdictions.findIndex(j => j.id === result.id);
                if (index !== -1) {
                    this.jurisdictions[index] = result;
                }

                this.searchService.updateJurisdictions([result]).subscribe({
                    next: () => {
                        this.snackbarService.successSnackBar('Jurisdiction details updated successfully');
                    },
                    error: (err) => {
                        this.snackbarService.errorSnackBar('Failed to update jurisdiction details. Please try again.');
                    }
                });
            }
        });
    }
}
